// テーブルカラム設定
const Column = {
  namespaced: true,

  state: {
    columns: [],
    tableWidth: 0,
    isShow: false,
  },
  getters: {
    getColumns: state => {
      return state.columns
    },
    getTableWidth: state => {
      return state.tableWidth
    },
    getIsShow: state => {
      return state.isShow
    },
  },
  mutations: {
    setColumns(state, columns) {
      state.columns = columns
    },
    setTableWidth(state, width) {
      state.tableWidth = width
    },
    setIsShow(state, isShow) {
      state.isShow = isShow
    },
  },
  actions: {},
}

export default Column
